export default {
  cake: {
    56: '0x6F89660fEf8B6a03a41E5F3d0306645BE2469eFE',// '0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6',
    97: '',
  },
  masterChef: {
    56: '0x7277f31D5a16712029d04E7d68815a2aBA146f75',// '0xe70E9185F5ea7Ba3C5d63705784D8563017f2E57',
    97: '',
  },
  wbnb: {
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    97: '',
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '',
  },
  dmgk: { 
    56: '0x6F89660fEf8B6a03a41E5F3d0306645BE2469eFE',
    97: '',
  },
}
